import script from "./update-tips.vue?vue&type=script&setup=true&lang=js"
export * from "./update-tips.vue?vue&type=script&setup=true&lang=js"

import "./update-tips.vue?vue&type=style&index=0&id=3384c464&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3384c464"]])

export default __exports__